precision highp float;

uniform float time;
varying float vAlpha;
varying float vRandom;

float hash(vec2 p) { 
  return fract(sin(dot(p, vec2(127.1,311.7))) * 43758.5453123); 
}

float noise(vec2 p){
  vec2 i = floor(p); 
  vec2 f = fract(p);

  float a = hash(i); 
  float b = hash(i + vec2(1.0, 0.0));
  float c = hash(i + vec2(0.0, 1.0)); 
  float d = hash(i + vec2(1.0, 1.0));

  vec2 u = f * f * (3.0 - 2.0 * f);

  return mix(a, b, u.x) + 
         (c - a) * u.y * (1.0 - u.x) + 
         (d - b) * u.x * u.y;
}

float fbm(vec2 p){
  float v = 0.0; 
  float amp = 0.5;
  for(int i = 0; i < 3; i++){
    v += amp * noise(p);
    p *= 2.0;
    amp *= 0.5;
  }
  return v;
}

float getShieldDist(vec2 p) {
  p.x = abs(p.x);

  float top = p.y - 0.35 + (p.x * p.x * 0.45);
  float side = p.x + (p.y * 0.2) - 0.35;

  if(p.y < 0.0) {
    float ay = abs(p.y);
    side += ay * sqrt(ay) * 0.85;
  }

  return max(top, side);
}

void main() {

  vec2 uv = vec2(gl_PointCoord.x - 0.5, 0.5 - gl_PointCoord.y);

  vec2 p = uv * 1.3;

  float shieldDist = getShieldDist(p);
  float len = shieldDist + 0.35;

  vec2 flow = vec2(
    sin(time * 0.15 + uv.y * 4.0),
    cos(time * 0.12 + uv.x * 3.0)
  ) * 0.03;

  vec2 ncoord = uv * 3.0 + flow;

  float n = fbm(
    ncoord + vec2(
      time * 0.03 + vRandom * 8.0,
      time * 0.015
    )
  );

  float noisy = mix(0.92, 1.08, n);

  float edge = smoothstep(0.08, -0.02, shieldDist);

  float core = pow(clamp(1.0 - len / 0.35, 0.0, 1.0), 2.2);
  float halo = pow(clamp(1.0 - len / 0.7, 0.0, 1.0), 1.4);

  float alpha = (core * 0.9 + halo * 0.25);
  alpha *= edge;
  alpha *= noisy;
  alpha *= vAlpha;

  float shimmer = 0.92 + 0.08 * sin(
    time * 2.0 + vRandom * 12.0 + uv.x * 10.0
  );
  alpha *= shimmer;

  if (alpha < 0.002) {
    discard;
  }

  vec3 dark = vec3(0.03, 0.05, 0.08);
  vec3 glow = vec3(0.35, 0.55, 0.75);
  vec3 spec = vec3(0.85, 0.92, 1.0);

  vec3 col = dark;

  col += glow * halo * 0.35;
  col += spec * core * (0.5 + 0.5 * vRandom);

  col += core * 0.25;

  gl_FragColor = vec4(col, alpha);
}